export enum CALPADSMeetingTypeEnum {
  PartBInitial = 10,
  PartCInitial = 15,
  AnnualIEP = 20,
  Pending = 30,
  TriennialEvaluationIep = 40
}
